import { MapPin, Phone, Clock, Instagram } from "lucide-react";

export const Footer = () => {
  return (
    <footer
      id="contact"
      data-testid="footer-section"
      className="relative bg-black border-t border-zinc-900"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="grid lg:grid-cols-12 gap-12">
          {/* Big Heading */}
          <div className="lg:col-span-6">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-sky-400" />
              <span className="font-mono text-[11px] tracking-[0.3em] text-sky-400 uppercase">
                Contact / Visit
              </span>
            </div>
            <h2 className="font-display text-white text-5xl md:text-6xl lg:text-7xl uppercase leading-[0.9]">
              Ελατε να <br />
              γνωριστουμε <br />
              <span className="text-sky-400">απο κοντα.</span>
            </h2>
            <p className="mt-8 max-w-md text-zinc-400 leading-relaxed">
              Καθημερινές, Σαββατοκύριακα, αργίες. Η πόρτα είναι ανοιχτή από νωρίς
              το πρωί μέχρι πολύ αργά το βράδυ.
            </p>
          </div>

          {/* Contact grid */}
          <div className="lg:col-span-6 grid sm:grid-cols-2 gap-6">
            <ContactCard
              icon={MapPin}
              label="Address"
              value="Ιατριδου 8"
              sub="Χαλκίδα 341 00"
              href="https://maps.google.com/?q=Iatridou+8+Chalkida"
              testid="footer-address"
            />
            <ContactCard
              icon={Phone}
              label="Phone"
              value="22210 20988"
              sub="Καλέστε μας"
              href="tel:2221020988"
              testid="footer-phone"
              mono
            />
            <ContactCard
              icon={Clock}
              label="Hours"
              value="Early Morning →"
              sub="Πολύ αργά το βράδυ"
              testid="footer-hours"
            />
            <ContactCard
              icon={Instagram}
              label="Instagram"
              value="@ted.cafe.chk"
              sub="Follow us"
              href="https://www.instagram.com/ted.cafe.chk/"
              testid="footer-instagram"
            />
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-24 pt-8 border-t border-zinc-900 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <span className="h-2.5 w-2.5 rounded-full bg-sky-400 shadow-[0_0_16px_rgba(250,204,21,0.9)]" />
            <span className="font-display text-white text-sm tracking-widest uppercase">
              TED <span className="text-sky-400">/</span> FUN SPOT
            </span>
          </div>
          <div className="font-mono text-[10px] tracking-[0.25em] text-zinc-600 uppercase">
            © 2026 Ted Coffee & Fun Spot · Powered by Gaming & Caffeine
          </div>
        </div>
      </div>

      {/* Massive brand mark */}
      <div className="overflow-hidden">
        <div className="text-center leading-none pb-6">
          <span className="font-display text-sky-400/10 text-[18vw] uppercase select-none tracking-tighter">
            TED · SPOT
          </span>
        </div>
      </div>
    </footer>
  );
};

const ContactCard = ({ icon: Icon, label, value, sub, href, testid, mono }) => {
  const Wrapper = href ? "a" : "div";
  const props = href
    ? {
        href,
        target: href.startsWith("http") ? "_blank" : undefined,
        rel: "noreferrer noopener",
      }
    : {};
  return (
    <Wrapper
      {...props}
      data-testid={testid}
      className="group border border-zinc-800 bg-zinc-950/40 p-6 hover:border-sky-400/60 transition-colors block"
    >
      <div className="flex items-center gap-2 text-zinc-500 mb-4">
        <Icon className="w-4 h-4" />
        <span className="font-mono text-[10px] tracking-[0.3em] uppercase">
          {label}
        </span>
      </div>
      <div
        className={`text-white text-xl uppercase group-hover:text-sky-400 transition-colors ${
          mono
            ? "font-mono tracking-wider tabular-nums"
            : "font-display"
        }`}
      >
        {value}
      </div>
      <div className="text-zinc-500 text-sm mt-1">{sub}</div>
    </Wrapper>
  );
};
